module.exports = __webpack_public_path__ + "media/components/maps/incidents/icons/social_unrest-440095971b9432b6a76ad584a04f46b9.png";